import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropActiveNotices } from '~/navigation/Navigation.types';

import { NoticeItem } from '../Notice.Item';
import { ActiveNoticesList, ActiveNoticesListNative } from './ActiveNotice.List';

export const ActiveNoticesScreen = (props: ScreenPropActiveNotices) => {
  return (
    <PageContainer>
      <ActiveNoticesLayout {...props} />
    </PageContainer>
  );
};

export const ActiveNoticesLayout = (props: ScreenPropActiveNotices) => {
  const activeNoticesId = props.route.params?.id;
  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(activeNoticesId);
  }, [activeNoticesId]);

  return (
    <ScreenTwoPageLayout>
      {isWeb ? (
        <ActiveNoticesList onPress={(item) => setId(item.id)} />
      ) : (
        <ActiveNoticesListNative />
      )}
      {id ? <NoticeItem noticeId={id} onClose={() => setId(undefined)} /> : <></>}
    </ScreenTwoPageLayout>
  );
};
